<template>
  <div style="position: relative;" class="tracktask">
    <div class="content-container"  v-if="type == 1">
        <div>
          <h3 class="title" >跟踪任务</h3>
        </div>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :xs="24" :sm="12" :md="8" :lg="6" >
            <ul class="error-messages" v-if="!isEmptyErrors">
              <li v-for="error in errors">{{error[0].message}}</li>
            </ul>
            <el-form :model="form" :rules="rules" ref="form" class="demo-ruleForm">
              <el-form-item label="" prop="order_no">
                <!-- <el-input v-model="form.order_no" placeholder="任务号"></el-input> -->
                <YueDanIpt v-on:blur="blur"  model="order_no" :object="form" placeholder="任务号"></YueDanIpt>
              </el-form-item>
              <el-form-item label="" prop="mobile">
                <!-- <el-input v-model.number="form.mobile" placeholder="买单人/收件人手机号"></el-input> -->
              <YueDanIpt :reg="/^[0-9]*$/"  model="mobile" :object="form" placeholder="买单人/收件人手机号"></YueDanIpt>
              </el-form-item>
            </el-form>
            <el-button class="block" type="primary" style="margin-top:40px;" @click="submit()" :loading="loading">查看任务</el-button>
          </el-col>
        </el-row>
    </div>
    <div  class="content-container tt-custom-tab" v-if="type == 2">
      <div>
        <h3 class="title" >跟踪任务</h3>
      </div>
      <Order
        :bussinessList="bussinessList"
        :singleList="singleList"
        :order="order"
        :isSingle="isSingle"
        :trackTask="true">
      </Order>
    </div>
  </div>
</template>

<script>
import YueDanIpt from '../../components/YueDanIpt'
import Order from '../orders/list/Order'
import api from '../../services/api.js'
import Loading from '../../components/Loading'
let _ = require('lodash')

export default {
  name: 'Orders',
  components: {
      Order: Order,
      YueDanIpt:YueDanIpt,
      Loading: Loading
  },
  created () {
    this.form.order_no = this.$route.query.TaskNo || ''
    this.getGroupBussinessList()
    this.getSingleList()
  },
  data () {
    return {
      form:{
        order_no:'',
        mobile:''
      },
      isEmptyErrors: true,
      errors:null,
      type: 1,
      loading:false,
      isSingle:false,
      keyword: null,
      order: null,
      bussinessList: null,
      singleList: null,
      rules: {}
    }
  },
  methods: {
    async getOrders () {
      this.isEmptyErrors = true
      this.errors = null
      this.orders = null
      let res = await api.post(this, {
        path: 'order.php',
        api: 'track_task',
        data: this.form,
        loading: 'loading'
      })
      res = res.body
      if(res.status == 'ok'){
        this.order = res.result
        this.order.address_info = this.order.address || {}
        this.$router.push(
          {
            path: this.$route.path,
            query: {
              TaskNo: this.form.order_no
            }
          }
        )
        this.type=2
      }else{
        switch (res.result) {
          case 'wrong_mobile':
            this.isEmptyErrors = false
            this.errors = {
              mobile: [
                {message: '手机号跟任务号不匹配'}
              ]
            }
            break;
          case 'no_such_order_no':
            this.isEmptyErrors = false
            this.errors = {
              mobile: [
                {message: '此任务号不存在'}
              ]
            }
            break;
          case 'wrong_order_type':
            this.isEmptyErrors = false
            this.errors = {
              mobile: [
                {message: '只支持代买任务的跟踪'}
              ]
            }
            break;
        }
      }
      
    },
    blur(){
       this.form.order_no=this.form.order_no.replace(/^\s*|\s*$/g,"")
    },
    async getGroupBussinessList () {
      let res = await api.getGroupBussinessList(this, {setLs: true, getLs: true,getLsTime: new Date().getTime()})
      let result = res.body.result
      this.bussinessList = _.groupBy(result, 'id')
    },
    async getSingleList () {
      let res = await api.getSingleList(this, {setLs: true, getLs: true})
      let result = res.body.result
      this.singleList = _.groupBy(result, 'id')
    },
    submit () {
      this.isEmptyErrors= true
      this.errors = null
      if(!this.form.order_no){
        this.isEmptyErrors = false
        this.errors = {
          business_name: [
            {message: '请输入正确的任务号'}
          ]
        }
        if(!this.form.mobile){
          this.errors = {
            business_name: [
              {message: '请输入正确的任务号'}
            ],
            mobile: [
              {message: '请输入正确的手机号'}
            ]
          }
        }else{
          if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.mobile))){
            this.errors = {
              business_name: [
                {message: '请输入正确的任务号'}
              ],
              mobile: [
                {message: '请输入正确的手机号'}
              ]
            }
          }
        }
      }else{
        if(!(/^JO\d{14}$/.test(this.form.order_no))){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的任务号'}
            ]
          }
          if(!this.form.mobile){
            this.isEmptyErrors = false
            this.errors = {
              business_name: [
                {message: '请输入正确的任务号'}
              ],
              mobile: [
                {message: '请输入正确的手机号'}
              ]
            }
          }else{
            if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.mobile))){
              this.isEmptyErrors = false
              this.errors = {
                business_name: [
                  {message: '请输入正确的任务号'}
                ],
                mobile: [
                  {message: '请输入正确的手机号'}
                ]
              }
            }
          }
        }else{
          if(!this.form.mobile){
            this.isEmptyErrors = false
            this.errors = {
              mobile: [
                {message: '请输入正确的手机号'}
              ]
            }
          }else{
            if(!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form.mobile))){
              this.isEmptyErrors = false
              this.errors = {
                mobile: [
                  {message: '请输入正确的手机号'}
                ]
              }
            }
          }
        }
      }
      if(!this.isEmptyErrors){
        return
      }
      this.getOrders()
    }
  },
  watch: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content-container {
    padding: 0 10%;
    width: 100%;
    min-height: 40vh;

    & > div {
      padding: 0 85px 0 30px;
    }
    .input {
      padding: 0 100px
    }
    .title {
      height:20px;
      font-size:18px;
      color:rgba(51,51,51,1);
      line-height:20px;
      text-align: center;
      margin-bottom: 60px;
    }
    .error-messages{
      background-color: #FFF1F1;
      padding: 10px;
      text-align: center;
      color: #FF4650;
      line-height: 17px;
      margin-bottom: 10px;
      border-radius: 5px;
    }
  }
  .revise {
    display:  inline-block;
    width: 100%;
  }
.empty-orders-container {
  font-size:16px;
  color:rgba(102,102,102,1);
  line-height:22px;
  text-align: center;
  padding: 133px 0 200px
}
.yd-pagination {
  position: absolute;
  bottom: -70px;
  width: 100%;
}
  @media screen and (max-width:1024px) {
    .mobile-select {
      width: 60%;
    }
    .content-container {
      padding: 0 10px;
      min-height: 56vh;

      & > div {
        padding: 0 10px;
      }
      .title {
        margin-top: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/tracktask/Tracktask.vue